import React from "react";

/**
 * VisibilityChip — small inline chip that cycles a Working Journal entry's
 * visibility level (Private → Team → Firm → Private).
 *
 * Extracted from `ReflectionCanvasArticle` during the Phase-A hardening
 * refactor. Behavior, styling, `data-testid`, and accessibility copy are
 * preserved verbatim from the inline version so no existing tests need
 * to change.
 *
 * Props:
 *   vis        — one of "private" | "team" | "firm" (defaults to "team")
 *   onCycle    — click handler; cycling logic lives in the parent so this
 *                stays a pure presentational component
 *   dataTestId — required for QA selectors
 */
export default function VisibilityChip({ vis, onCycle, dataTestId }) {
  const cfg = {
    private: { label: "Private", color: "bg-foreground" },
    team:    { label: "Team",    color: "bg-muted-foreground" },
    firm:    { label: "Firm",    color: "bg-brass" },
  }[vis || "team"];
  return (
    <button
      type="button"
      onClick={onCycle}
      title="Click to cycle visibility · Private → Team → Firm"
      data-testid={dataTestId}
      className="inline-flex items-center gap-1.5 border border-border/70 bg-card px-2 py-0.5 text-[0.625rem] font-mono uppercase tracking-widest text-muted-foreground hover:text-primary hover:border-primary transition-colors"
    >
      <span className={`w-1.5 h-1.5 rounded-full ${cfg.color}`} aria-hidden />
      {cfg.label}
    </button>
  );
}
